import { useAuth } from "../context/auth";
import { apiUrls } from "../helpers/apiUrls";
import { makeRequest } from "../helpers/makeRequest";
import { useAxiosPrivate } from "../hooks/useAxiosPrivate";

export default function useLandingPageService() {
    const axiosPrivate = useAxiosPrivate();
    const userData = useAuth();

    const getLeadsCount = () => {
        return makeRequest(axiosPrivate, apiUrls.sales.leads.count);
    };

    const getCustomersCount = () => {
        return makeRequest(axiosPrivate, apiUrls.customers.count);
    };

    const getContactsCount = () => {
        return makeRequest(axiosPrivate, apiUrls.sales.contacts.count);
    };

    const getPersonsCount = () => {
        return makeRequest(axiosPrivate, apiUrls.sales.persons.count);
    };

    const getBookingsCount = () => {
        return makeRequest(axiosPrivate, apiUrls.bookings.count);
    };

    const getProductsCount = () => {
        return makeRequest(axiosPrivate, apiUrls.products.count);
    };

    const getProposalsCount = () => {
        return makeRequest(axiosPrivate, apiUrls.products.proposalCount);
    };

    function getTasksCount() {
        return makeRequest(axiosPrivate, apiUrls.tasks.count(userData?.user?.user_id));
    }

    const getOffersCount = () => {
        return makeRequest(axiosPrivate, apiUrls.offers.count);
    };

    const getAgreementsCount = () => {
        return makeRequest(axiosPrivate, apiUrls.agreements.count);
    };

    const getAgreementOverduePaymentsCount = () => {
        return makeRequest(axiosPrivate, apiUrls.agreements.agreementOverduePaymentsCount);
    };

    return {
        getLeadsCount,
        getCustomersCount,
        getContactsCount,
        getPersonsCount,
        getBookingsCount,
        getProductsCount,
        getTasksCount,
        getOffersCount,
        getAgreementsCount,
        getProposalsCount,
        getAgreementOverduePaymentsCount
    };
}
